
import { MapTo } from '@adobe/aem-react-editable-components';
import CorporateLogoNavigation, { CorporateLogoNavigationEditConfig } from './CorporateLogoNavigation';

export default MapTo('cob-corp-acquisition/components/creditonebank/corporate-logo-navigation')(CorporateLogoNavigation, CorporateLogoNavigationEditConfig);
        